
declare var Object: any;
export interface TripSignatureStatsInterface {
  "id"?: string;
  "vdate"?: any;
  "serviceType"?: string;
  "appName"?: string;
  "tenantId": number;
  "consumerId"?: number;
  "employeeId"?: number;
  "count": number;
  "units"?: number;
}

export class TripSignatureStats implements TripSignatureStatsInterface {
  "id": string;
  "vdate": any;
  "serviceType": string;
  "appName": string;
  "tenantId": number;
  "consumerId": number;
  "employeeId": number;
  "count": number;
  "units": number;
  constructor(data?: TripSignatureStatsInterface) {
    Object.assign(this, data);
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `TripSignatureStats`.
   */
  public static getModelName() {
    return "TripSignatureStats";
  }

  /**
  * This method creates an instance of TripSignatureStats for dynamic purposes.
  **/
  public static factory(data: TripSignatureStatsInterface): TripSignatureStats{
    return new TripSignatureStats(data);
  }

  /**
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'TripSignatureStats',
      plural: 'TripSignatureStats',
      path: 'TripSignatureStats',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "vdate": {
          name: 'vdate',
          type: 'any'
        },
        "serviceType": {
          name: 'serviceType',
          type: 'string'
        },
        "appName": {
          name: 'appName',
          type: 'string'
        },
        "tenantId": {
          name: 'tenantId',
          type: 'number'
        },
        "consumerId": {
          name: 'consumerId',
          type: 'number'
        },
        "employeeId": {
          name: 'employeeId',
          type: 'number'
        },
        "count": {
          name: 'count',
          type: 'number'
        },
        "units": {
          name: 'units',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
